import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import {
  TextBlock,
  // MediaBlock,
  // TextRow,
  RectShape
  // RoundShape
} from 'react-placeholder/lib/placeholders';
import View from '../../view';
import Text from '../../text';

const AwesomePlaceholder = (
  <View className="my-awesome-placeholder">
    <RectShape color="blue" style={{ width: 30, height: 80 }} />
    <TextBlock rows={7} color="yellow" />
  </View>
);
const MatchCard = () => {
  return (
    <ReactPlaceholder customPlaceholder={AwesomePlaceholder} ready={true}>
      <Text>{'hii'}</Text>
    </ReactPlaceholder>
  );
};

export default MatchCard;
